var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-content"},[_c('div',{staticClass:"chat-entry chat-entry-event text-secondary"},[(_vm.entry.actor)?_c('p',{staticClass:"m-0"},[_vm._v(" "+_vm._s(_vm.resolveEventEntryPayload(_vm.entry))+" ")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }